"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="hidden md:flex gap-6">
        {[1, 2, 3, 4, 5].map(i => <div key={i} data-index={i} className="h-6 w-16 bg-muted/20 animate-pulse rounded" />)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="hidden md:block">
      <NavigationMenuList className="gap-6">
        {menuItems.slice(0, 5).map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm font-medium text-foreground transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] relative hover:!bg-transparent focus:!bg-transparent after:absolute after:bottom-[-4px] after:left-0 after:h-[2px] after:w-0 after:bg-primary-light after:transition-all after:duration-[var(--duration-medium)] after:ease-[var(--ease-smooth)] hover:after:w-full focus:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function HeaderCTA() {
  return <div className="flex items-center gap-3">
      <SearchBar />
      <Button asChild className="hidden md:inline-flex hover:!bg-transparent focus:!bg-transparent bg-primary text-foreground-primary hover:scale-105 hover:shadow-medium active:scale-100 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)]">
        <Link to="#">Get Started</Link>
      </Button>
    </div>;
}
function SearchBar() {
  const [isExpanded, setIsExpanded] = useState(false);
  return <div className="relative">
      {isExpanded ? <Input type="search" placeholder="Search..." className="w-48 h-9 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" onBlur={() => setIsExpanded(false)} autoFocus /> : <Button variant="ghost" size="icon" onClick={() => setIsExpanded(true)} className="hover:!bg-transparent focus:!bg-transparent hover:scale-110 transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)]">
          <Search className="size-5 text-foreground" />
        </Button>}
    </div>;
}
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  return <header className={`sticky top-0 z-50 w-full bg-background/95 backdrop-blur-md border-b border-border transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isScrolled ? "h-16 shadow-soft" : "h-22"}`}>
      <div className="container mx-auto px-4 h-full flex items-center justify-between">
        <Link to="/#" className="flex-shrink-0">
          <img src="https://omwmgmt.com/wp-content/uploads/2026/01/White-and-Blue-Modern-Real-Estate-Logo-2.png" alt="Omni Wealth Management" className="!h-[56px]" />
        </Link>

        <MenuProvider menu_id="6" className="flex-1 flex justify-center">
          <HeaderMenuConsumer />
        </MenuProvider>

        <HeaderCTA />
      </div>
    </header>;
}